<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1">
<p class="half-title">NAPOLEON’S IMPERIAL GUARD UNIFORMS AND EQUIPMENT</p>
<p class="sub-title">THE CAVALRY</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half-Title.vue?21d381ff